/**
 * Functionality to handle closingtime RadioSpots in the activation dialog.
 *
 * This adds time and minutesBeforeClosing fields that can be populated
 * e.g. by the ClosingtimeControls.vue widget.
 *
 * Depends on either:
 *   - this.contents
 * or
 *   - this.entries
 *
 * but can also handle none of those existing, e.g. for the TickerDetail
 * page, in which case this does nothing.
 *
 */

import {isRadioSpot, isClosingTimeRadioSpot} from '@/mixins/identifiers.js';
import {WORKDAY_INDICES} from '@/mixins/weekdays.js';

export default {
  data() {
    return {
      // weekDays already assumed to exist e.g. via timing.js
      time: null,
      minutesBeforeClosing: 10,
      closingTimeFormIsValid: true,
    };
  },
  computed: {
    /**
     * Abstracted data source, so we can support both this.contents and this.entries.
     */
    closingtimeRelevantContents() {
      if (this.contents !== undefined && this.contents !== null) {
        return this.contents;
      } else if (this.entries !== undefined && this.entries !== null) {
        return this.entries
          .filter((entry) => entry.spot !== undefined)
          .map((entry) => entry.spot);
      }
      return [];
    },
    radioSpots() {
      return this.closingtimeRelevantContents.filter((content) =>
        isRadioSpot(content)
      );
    },
    closingTimeRadioSpots() {
      return this.closingtimeRelevantContents.filter((content) =>
        isClosingTimeRadioSpot(content)
      );
    },
    contentsAreOnlyClosingTimeRadioSpots() {
      return (
        this.closingTimeRadioSpots.length > 0 &&
        this.closingTimeRadioSpots.length ===
          this.closingtimeRelevantContents.length
      );
    },
    contentIncludesClosingTimeRadioSpots() {
      return this.closingTimeRadioSpots.length > 0;
    },
    contentMixesClosingTimeAndNormalRadioSpots() {
      const moreThanOneRadioSpot = this.radioSpots.length > 1;
      const mixed =
        this.closingTimeRadioSpots.length !== this.radioSpots.length;
      return moreThanOneRadioSpot && mixed;
    },
  },
  methods: {
    /**
     * Closingtime radiospots should default to the workweek.
     */
    getDefaultWeekdaysForClosingTimeRadioSpot() {
      return WORKDAY_INDICES;
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/entryCreationUpdateDialogClosingTime.js